import AWS from 'aws-sdk';
import CONFIG from '../aws.config.json';

AWS.config.update({
  apiVersion: CONFIG.api_version,
  region: CONFIG.region,
  accessKeyId: CONFIG.access_key,
  secretAccessKey: CONFIG.secret_key
});
const s3 = new AWS.S3({
  params: { Bucket: CONFIG.bucket }
});
export default {
  getObjectsListByHash(hash) {
    return s3.listObjects({ Bucket: CONFIG.bucket, Prefix: hash }).promise();
  },
  getObject(data) {
    return s3.getObject({ Bucket: CONFIG.bucket, Key: data }).promise();
  }
};
